import { styled } from '@mui/material';
import Box from '@mui/material/Box';

import { theme } from '../../../../../../theme';

export const StyledLineContainerBox = styled(Box, {
    shouldForwardProp: (propName: string) => propName !== 'existing',
})<{ selected?: boolean; existing?: boolean }>`
    margin: 20px 10px;
    padding: 10px 0px;
    border-radius: 5px;
    &:hover {
        box-shadow: 0 2px 10px 2px rgba(0, 0, 0, 0.15);
    }
    ${({ selected }) => (selected ? 'background: #245F88' : '')}
    ${({ existing }) =>
        !existing ? { borderColor: theme.palette.warning.main, borderStyle: 'solid', borderWidth: '0.4px' } : ''}
`;
